import httpbaseURL from "../common/axios";

class SupplierCategoryMappingService {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/SupplierCategoryMapping/Create",
      doc
    );
  }

  getfindonedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/SupplierCategoryMapping/Get?id=" + doc
    );
  }

  updatedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/SupplierCategoryMapping/Update",
      doc
    );
  }
  deletedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/SupplierCategoryMapping/Delete?id=" + doc
    );
  }
  // category list

  CategoryList() {
    return httpbaseURL.httpMSInventoryUrl.get("SupplierCategoryMapping/List");
  }
  suppliercategorymappinglist() {
    return httpbaseURL.httpMSInventoryUrl.get(
      "SupplierCategoryMapping/ListView"
    );
  }
  GetSupplierByCategory(CategoryId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "SupplierCategoryMapping/GetByCategoryId?CategoryId=" + CategoryId
    );
  }

  GetSupplierByMultipleCategory(CategoryIds, BranchId, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "SupplierCategoryMapping/GetSupplierByMultipleCategory?CategoryIds=" +
      CategoryIds + "&HospitalId=" + HospitalId + "&BranchId=" + BranchId
    );
  }
}
export default new SupplierCategoryMappingService();
